var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27855 0.221529C4.31335 0.255431 4.46215 0.383438 4.58455 0.502679C5.35435 1.20175 6.61435 3.02543 6.99895 3.97993C7.06075 4.12489 7.19155 4.49138 7.19995 4.68719C7.19995 4.87482 7.15675 5.05368 7.06915 5.22435C6.94675 5.43712 6.75415 5.60779 6.52675 5.70132C6.36895 5.76152 5.89675 5.85504 5.88835 5.85504C5.37175 5.94856 4.53235 6 3.60475 6C2.72095 6 1.91575 5.94856 1.39135 5.87199C1.38295 5.86322 0.796151 5.7697 0.595151 5.66741C0.227952 5.47979 -4.85599e-05 5.1133 -4.85256e-05 4.72109L-4.85226e-05 4.68719C0.0089518 4.43176 0.236952 3.89459 0.245352 3.89459C0.630552 2.99152 1.82875 1.20994 2.62495 0.493911C2.62495 0.493911 2.82955 0.292255 2.95735 0.204578C3.14095 0.0678026 3.36835 -3.34969e-07 3.59575 -3.15089e-07C3.84955 -2.92901e-07 4.08595 0.0765702 4.27855 0.221529Z",
    fill: "#009841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickerIcon);
export default __webpack_public_path__ + "static/media/ticker-icon.9af769a4e1b4f0f5cd5537799eb6ce92.svg";
export { ForwardRef as ReactComponent };